<template>
  <div id="products-form" v-if="enabled">
    <div class="modal-background"></div>
    <div class="modal" @click="closeModal">
      <div class="products-modal" @click.stop="">
        <div class="modal_inner">
          <button class="close_modal" @click="closeModal">✖</button>
          <div class="form-step" v-if="step == 1">

            <div class="header">
              <span class="section-title">{{titlePlaceholder}}</span>
              <span class="section-subtitle" v-if="currentProductType === 'module'" >{{moduleSubtitle}}</span>
              <span class="section-subtitle" v-else-if="currentProductType === 'ebook'" >{{ebookSubtitle}}</span>
            </div>

            <form
              class="products-form-form"
              @submit.prevent=""
              novalidate="true"
            >

              <div class="form_body">

                  <div
                    :class="{ 'input_error': errors.name }"
                    class="input_wrapper"
                  >
                    <input
                      v-model="name"
                      type="text"
                      class="form_field"
                      :placeholder="errors.name || namePlaceholder"
                    >
                  </div>

                  <div
                    :class="{ 'input_error': errors.company }"
                    class="input_wrapper"
                  >
                    <input
                      v-model="company"
                      type="text"
                      class="form_field"
                      :placeholder="errors.company || companyPlaceholder"
                    >
                  </div>

                 <div
                    :class="{ 'input_error': errors.email }"
                    class="input_wrapper"
                  >
                    <input
                      v-model="email"
                      type="email"
                      class="form_field"
                      :placeholder="errors.email || emailPlaceholder"
                    >
                  </div>

                  <div
                    :class="{ 'input_error': errors.industry }"
                    class="input_wrapper"
                  >
                    <v-select
                      v-model="selectedIndustry"
                      :options="industries"
                      :placeholder="industry"
                      :searchable="false"
                    ></v-select>
                  </div>

                  <div
                    :class="{ 'input_error': errors.agree }"
                    class="input_wrapper fullwidth agree"
                  >
                    <input
                      v-model="agreeChecked"
                      type="checkbox"
                      class="form_field"
                      id="agree-checkbox"
                    >

                    <label
                      for="agree-checkbox"
                    >{{agree}}</label>
                  </div>

                  <div class="recaptcha">
                    <vue-recaptcha
                      :sitekey="content.captcha"
                      @verify="reCaptchaVerified = true"
                      @expired="reCaptchaVerified = false"
                    >
                    </vue-recaptcha>

                    <div v-if="errors.captcha" class="input_error">{{ captchaError }} </div>
                  </div>

                  <label for="amex" style="display:none">AMEX</label>
                  <input type="hidden" name="amex" value="" id="amex">

                  <div
                    class="input_wrapper fullwidth submit"
                  >
                    <button
                      type="submit"
                      class="primary-flip"
                      @click="validateFields"
                      v-if="currentProductType === 'module'"
                    >{{moduleButton}}</button>

                    <button
                      type="submit"
                      class="primary-flip"
                      @click="validateFields"
                      v-if="currentProductType === 'ebook'"
                    >{{ebookButton}}</button>

                  </div>

              </div>

            </form>

          </div>
          <div class="finish-step" v-if="step == 2">
            <div class="header">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="72" height="72" viewBox="0 0 72 72"><g><g><image width="72" height="72" xlink:href="data:image/png;base64,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"/></g></g></svg>
              <span class="section-title">{{finishedTitle}}</span>
              <span class="section-subtitle" v-if="currentProductType === 'module'" >{{finishedModuleSubtitle}}</span>
              <span class="section-subtitle" v-else-if="currentProductType === 'ebook'" >{{finishedEbookSubtitle}}</span>
            </div>

            <div class="buttons">
                <a
                  type="submit"
                  class="primary-flip"
                  href="/produkty"
                >{{seeOtherProducts}}</a>

                <a
                  type="submit"
                  class="primary-flip"
                  href="/blog"
                >{{goToBlog}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import content from '@/translations/content'
import VueRecaptcha from 'vue-recaptcha'
import axios from 'axios'

import vSelect from 'vue-select'

export default {
  name: 'app',
  mixins: [content],
  components: {
    vSelect,
    VueRecaptcha
  },
  data () {
    return {
      enabled: false,
      step: 1,
      errors: {
        name: false,
        company: false,
        email: false,
        industry: false,
        agree: false
      },
      industries: [],
      currentProductType: '',
      currentProduct: '',
      selectedIndustry: null,
      captcha: false,
      reCaptchaVerified: false,
      // API
      sending: false,
      success: false,
      errored: false,
      content: {},
      //GTM
      actual_page: window.location.href
    }
  },
  watch: {
    enabled (value) {
      const body = document.getElementsByTagName('body')

      if (!value) {
        this.reCaptchaVerified = false
        body[0].classList.remove('body-overflow')
      } else {
        body[0].classList.add('body-overflow')
      }
    }
  },
  methods: {
    openModal(productType, productNid) {
      this.enabled = true

      this.currentProductType = productType
      this.currentProduct = productNid
    },
    closeModal() {
      this.enabled = false

      this.step = 1

      this.name = ''
      this.company = ''
      this.email = ''
      this.currentProduct = ''
      this.selectedIndustry = null
      this.agreeChecked = false
    },
    validEmail (email) {
      const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return EMAIL_REGEX.test(email)
    },
    validateFields () {
      let errorsOccured = false

      if (!this.name) {
        this.name = ''
        this.errors.name = 'Uzupełnij to pole - Imię i nazwisko'
        errorsOccured = true
      } else {
        this.errors.name = false
      }

      if (!this.reCaptchaVerified) {
        this.errors.captcha = true
      } else {
        this.errors.captcha = false
      }

      if (!this.company) {
        this.company = ''
        this.errors.company = 'Uzupełnij to pole - Nazwa firmy'
        errorsOccured = true
      } else {
        this.errors.company = false
      }

      if (!this.validEmail(this.email)) {
        this.email = ''
        this.errors.email = 'Adres e-mail jest nieprawidłowy'
        errorsOccured = true
      } else {
        this.errors.email = false
      }

      if ( !this.selectedIndustry ) {
        this.selectedIndustry = null
        this.errors.industry = true
        errorsOccured = true
      } else {
        this.errors.industry = false
      }

      if ( !this.agreeChecked ) {
        this.errors.agree = true
        errorsOccured = true
      } else {
        this.errors.agree = false
      }

      if (!errorsOccured && this.reCaptchaVerified) {
        this.sendForm()
      }

    },
    sendForm () {
      this.sending = true
      this.errored = false
      this.success = false

      let data = {
        name: this.name,
        company: this.company,
        email: this.email,
        industry: this.selectedIndustry.value,
        agree: this.agreeChecked,
        product: this.currentProduct
      }

      var submissionFormData = new FormData();
      const currentPath = window.location.pathname;
      submissionFormData.append('current_path', currentPath);

      submissionFormData.append('data', JSON.stringify(data))

      axios
        .post('/api/v1/products/submission', submissionFormData, {headers: {'Content-Type': 'multipart/form-data'} })
        .then(response => {
            if (response.data.data.errors && response.data.data.errors.length !== 0 && response.data.data.status == 500) {
              var errors = response.data.data.errors

              if (errors.email) {
                this.email = ''
                this.errors.email = errors.email
              }
            } else {
              this.success = true
              //Google Tag Manager
              window.dataLayer = window.dataLayer || [];
              dataLayer.push({
                event: 'webform_submission',
                eventModel: {
                  form_id: 'product_download'
                }
              });

              this.autoCloseCountdown()
            }
        })
        .catch(error => {
          this.errored = true
          if (this.errors.email && typeof this.errors.email == 'string' ) {
            this.errored = false
          }
        })
        .finally(() => {
          this.sending = false
          this.step = 2
        })
    }
  },
  created () {
    const content = window.drupalSettings

    if (content) {
      this.content = content.brief
    } else {
      this.content = require('@/data/content.json')
    }

    const modalButtons = document.getElementsByClassName('product-form')

    let openModal = this.openModal

    document.addEventListener('click', function (event) {
      if (!event.target.matches('.product-form')) return;
        openModal(
          event.target.dataset.productType,
          event.target.dataset.productNid,
        )
    }, false);

    axios
    .get('/api/v1/industries/list')
    .then(response => {
      this.industries = response.data.data.industries
    })

  }
}
</script>
